import React, { useState, useEffect } from "react";
import { Modal, Button, Typography } from "antd";
import planoContratualService from "services/PlanoContratualService";

const { Title, Paragraph, Text } = Typography;

const STORAGE_KEY = "sorteio_resultado_modal_2026_06_02";
// Não exibir a partir de 06/06/2026 00:00 (horário local): aparece até o fim do dia 05/06.
const DEADLINE = new Date(2026, 5, 6);

/**
 * Modal de agradecimento + resultado do sorteio de 1 ano de mensalidade.
 * Só aparece para assinantes pagantes (mesma regra do SorteioMensalidadeModal:
 * plano com valor fixo > 0). Aparece uma vez e não volta depois que o
 * profissional fecha (botão "Vamos juntos" ou clique fora). Some a partir de 06/06.
 */
const SorteioResultadoModal = () => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		checkPlanoAndShowModal();
	}, []);

	const checkPlanoAndShowModal = async () => {
		try {
			if (new Date() >= DEADLINE) return;
			if (localStorage.getItem(STORAGE_KEY)) return;

			// Mesma regra do sorteio: só exibe para assinantes pagantes
			// (plano com valor fixo > 0); não faz sentido para quem não participou.
			const planoAtual = await planoContratualService.getPlanoAtual();
			const valorFixo = parseFloat(
				planoAtual?.plano_contratual?.valor_fixo || 0,
			);
			if (valorFixo > 0) {
				setVisible(true);
			}
		} catch (error) {
			/* silencioso: não trava o app se a checagem de plano falhar */
		}
	};

	const handleClose = () => {
		try {
			localStorage.setItem(
				STORAGE_KEY,
				JSON.stringify({ closed: true, closedAt: new Date().toISOString() }),
			);
		} catch (error) {
			/* ignore */
		}
		setVisible(false);
	};

	return (
		<Modal
			open={visible}
			onCancel={handleClose}
			footer={null}
			width={520}
			centered
			closable={false}
			bodyStyle={{ padding: 0, borderRadius: 12, overflow: "hidden" }}
			style={{ borderRadius: 12 }}
		>
			<div style={{ padding: "24px 24px 22px" }}>
				<Title
					level={4}
					style={{
						textAlign: "center",
						margin: "0 0 18px",
						fontSize: 20,
						fontWeight: 700,
						lineHeight: 1.35,
					}}
				>
					Obrigado por construir o treino.io com a gente 🧡
				</Title>

				<img
					src={`${process.env.PUBLIC_URL}/img/sorteio-resultado.png`}
					alt="Tela do sorteio de 1 ano de mensalidade com a lista de participantes e o ganhador"
					style={{
						width: "100%",
						display: "block",
						borderRadius: 10,
						marginBottom: 18,
						boxShadow: "0 6px 20px rgba(0,0,0,0.18)",
						border: "1px solid rgba(0,0,0,0.06)",
					}}
				/>

				<div
					style={{
						textAlign: "center",
						background: "#fff7e6",
						border: "1px solid #ffd591",
						borderRadius: 8,
						padding: "12px 16px",
						marginBottom: 18,
					}}
				>
					<div
						style={{
							fontSize: 34,
							fontWeight: 800,
							lineHeight: 1,
							color: "#ff5722",
						}}
					>
						9,49
					</div>
					<Text style={{ fontSize: 13, color: "#ad6800" }}>
						nota média nas suas avaliações
					</Text>
				</div>

				<Paragraph style={{ fontSize: 14, marginBottom: 12 }}>
					Antes de tudo, <strong>parabéns ao ganhador</strong>! 🎉 O sorteio
					de 1 ano de mensalidade foi feito num site de sorteio, com
					todos os participantes na roda — do jeito mais transparente
					possível.
				</Paragraph>
				<Paragraph style={{ fontSize: 14, marginBottom: 12 }}>
					Queremos agradecer de coração a todo mundo que respondeu a
					pesquisa — lemos cada resposta. Ver essa nota média nos deixou
					muito felizes: é sinal de que vocês estão curtindo a plataforma.
				</Paragraph>
				<Paragraph style={{ fontSize: 14, marginBottom: 12 }}>
					O treino.io é construído com base nos seus feedbacks e sugestões.
					Vocês fazem parte do nosso sucesso, e ver tanta gente gostando do
					que a gente faz é o que nos move todos os dias.
				</Paragraph>
				<Paragraph style={{ fontSize: 14, marginBottom: 20 }}>
					Anotamos cada ponto de melhoria e cada novidade que vocês pediram.
					A partir de agora, nosso foco é <strong>100% nisso</strong>: deixar
					o que já existe ainda melhor e trazer o que vocês querem ver.
				</Paragraph>

				<Button
					type="primary"
					size="large"
					block
					onClick={handleClose}
					style={{ height: 46, fontWeight: 600 }}
				>
					Vamos juntos 🚀
				</Button>
			</div>
		</Modal>
	);
};

export default SorteioResultadoModal;
